import React from 'react';
import { useTranslation } from 'react-i18next';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import FormField from '../common/FormField';
import InputField from '../common/InputField';
import Modal from '../common/Modal';
import ModalFooter from '../common/ModalFooter';
import TextArea from '../common/TextArea';

type GroupFormValues = {
  groupName: string;
  remarks: string;
};

interface EditLubricantGroupModalProps {
  onClose: () => void;
  onSubmit: () => void;
  control: Control<GroupFormValues>;
  errors?: FieldErrors<GroupFormValues>;
  isEditMode?: boolean;
  isSubmitting?: boolean;
}

const EditLubricantGroupModal: React.FC<EditLubricantGroupModalProps> = ({
  onClose,
  onSubmit,
  control,
  errors,
  isEditMode = false,
  isSubmitting = false,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={true}
      onClose={onClose}
      size="sm"
      title={isEditMode ? t('lubricants.editGroupTitle') : t('lubricants.addGroupTitle')}
      footer={
        <ModalFooter
          onCancel={onClose}
          onSubmit={onSubmit}
          isLoading={isSubmitting}
          submitText={
            isSubmitting
              ? isEditMode
                ? t('buttons.updating')
                : t('buttons.adding')
              : isEditMode
                ? t('buttons.update')
                : t('buttons.add')
          }
        />
      }
    >
      <FormField label={t('form.groupName')} sx={{ mt: 2 }} required>
        <Controller
          name="groupName"
          control={control}
          rules={{ required: t('form.validation.groupNameRequired') }}
          render={({ field }) => (
            <InputField
              {...field}
              value={field.value || ''}
              placeholder={t('form.enterGroupName')}
              error={!!errors?.groupName}
              helperText={errors?.groupName?.message as string}
            />
          )}
        />
      </FormField>

      <FormField label={t('form.remarks')} sx={{ mt: 2 }}>
        <Controller
          name="remarks"
          control={control}
          render={({ field }) => (
            <TextArea
              {...field}
              value={field.value || ''}
              onChange={(e) => field.onChange(e.target.value)}
              placeholder={t('form.enterRemarks')}
              rows={3}
            />
          )}
        />
      </FormField>
    </Modal>
  );
};

export default EditLubricantGroupModal;
